@import './config';
@import '~@cewe-designsystem-stylecomponents/mixins/breakpoints';

:host {
  position: fixed;
  z-index: 200;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 0.5em calc(env(safe-area-inset-right, 0) + 0.5em) calc(env(safe-area-inset-bottom, 0) + 0.5em)
    calc(env(safe-area-inset-left, 0) + 0.5em);
  background-color: $footnote-bg-color;
}
